import {
  Banner,
  Button,
  DisplayText,
  Form,
  FormLayout,
  Spinner,
  ProgressBar,
  TextContainer,
} from "@shopify/polaris";
import React, { Component } from "react";
import api from "../../../api";
import InputField from "../components/InputField";
import Cookies from "js-cookie";
import CheckBoxField from "../components/CheckBoxField";
import utils from "../../../utils";

export default class CovidSubscriptionForm extends Component {
  constructor(props) {
    super(props);

    this.state = { submitted: false, loading: false };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validation = this.validation.bind(this);
  }

  componentDidMount() {
    const fromSchema = require("./covid-form-schema.json");
    this.setState({
      data: utils.formStateBuilder(fromSchema),
      formFields: fromSchema.fields,
      today: utils.currentDate(),
      tags: fromSchema.tags,
      onSubmit: fromSchema.onSubmit,
      formTitle: fromSchema.formTitle,
      formDescription: fromSchema.formDescription,
      submissionStatus: "",
      required_fields: fromSchema.required_fields,
    });
  }
  handleChange(key, value) {
    let temp = { ...this.state.data };
    temp[key] = value;
    this.setState({ data: temp });
  }
  validation() {
    let valid = true;
    let errorFields = [];
    this.state.required_fields.map((item) => {
      if (typeof this.state.data[item] === "string") {
        if (this.state.data[item].length === 0) {
          errorFields.push(item + "_error");
          valid = false;
        }
      } else if (typeof this.state.data[item] === "undefined") {
        errorFields.push(item + "_error");
        valid = false;
      }
    });
    let temp = { ...this.state.data };
    errorFields.map((error) => {
      temp[error] = true;
    });
    this.setState({ data: temp });
    return valid;
  }
  handleSubmit() {
    let valid = this.validation();
    if (valid) {
      this.props.isSubmitting(true);
      let data = utils.shopifyNewCustomerFormat(this.state.data);
      if (this.state.tags) {
        data.tags = this.state.tags;
      }
      api
        .newShopifyCustomer(data)
        .then((res) => {
          if (res.status === 200) {
            this.setState({ submissionStatus: "success", loading: false });
            Cookies.set("FirstCarePharamcyVaccine", this.state.today);
            this.props.isSubmitting(false);
          }
        })
        .catch((e) => {
          this.props.isSubmitting(false);
          this.setState({ submissionStatus: "error" });
        });
    }
  }
  render() {
    const {
      formFields,
      data,
      submissionStatus,
      onSubmit,
      formTitle,
      formDescription,
    } = this.state;
    const submissionSuccessBanner = submissionStatus === "success" && (
      <div style={{ paddingBottom: "20px" }}>
        <Banner
          title={onSubmit.success.message}
          status="success"
          action={{
            content: onSubmit.success.redirect.buttonLabel,
            onAction: () => window.open(onSubmit.success.redirect.src),
          }}
        />
      </div>
    );

    const submissionErrorBanner = submissionStatus === "error" && (
      <div style={{ paddingBottom: "20px" }}>
        <Banner
          title={onSubmit.success.message}
          status="error"
          action={{
            content: onSubmit.success.redirect.buttonLabel,
            onAction: () => window.open(onSubmit.success.redirect.src),
          }}
        />
      </div>
    );
    if (!formFields) {
      return <Spinner accessibilityLabel="Spinner example" size="large" />;
    }
    return (
      <div>
        <div class="form-container">
          {submissionSuccessBanner}
          {submissionErrorBanner}
          <div style={{ paddingBottom: "18px" }}>
            <DisplayText>{formTitle}</DisplayText>
            <TextContainer>
              <p>{formDescription}</p>
            </TextContainer>
          </div>
          <Form onSubmit={this.handleSubmit}>
            <FormLayout>
              {formFields.map((item) => {
                switch (item.component) {
                  case "text": {
                    return (
                      <InputField
                        error={data[item.key + "_error"]}
                        min={item.min}
                        value={data[item.key]}
                        onChange={this.handleChange}
                        fieldKey={item.key}
                        label={item.label}
                      />
                    );
                  }
                  case "checkbox":
                    return (
                      <CheckBoxField
                        label={item.label}
                        value={data[item.key]}
                        onChange={this.handleChange}
                        fieldKey={item.key}
                      />
                    );
                  case "group":
                    return (
                      <FormLayout.Group>
                        {item.fields.map((groupItem) => (
                          <InputField
                            required={item.required}
                            value={data[groupItem.key]}
                            onChange={this.handleChange}
                            fieldKey={groupItem.key}
                            label={groupItem.label}
                          />
                        ))}
                      </FormLayout.Group>
                    );
                }
              })}
              <Button submit primary>
                Submit
              </Button>
            </FormLayout>
          </Form>
        </div>
      </div>
    );
  }
}
